import {
    AssistantBill,
    AssistantCompany,
    AssistantCustomer,
    AssistantProductServiceOrder,
    AssistantReservation,
    AssistantReservationGroup,
    AssistantResource,
    AssistantResourceBlock,
    AssistantTravelAgency,
} from '@mews-commander/data-access';
import { AssistantSearchType, SearchType } from '../assistantSearchTypes';
import { AssistantResult } from '../query/useAssistantSearchQuery';
import { AssistantNavigation } from '../drawer/results/navigation/AssistantNavigation';
import { MergedSearchAndNavigationResult } from '../drawer/results/ResultListAndNavigations';

export type SearchTypeResult =
    | AssistantReservation
    | AssistantCompany
    | AssistantBill
    | AssistantCustomer
    | AssistantProductServiceOrder
    | AssistantTravelAgency
    | AssistantReservationGroup
    | AssistantResourceBlock
    | AssistantResource
    | AssistantNavigation;

export const assistantHasResult = (result: AssistantResult, mergedResult: MergedSearchAndNavigationResult): boolean =>
    (!!result.searchResult && assistantSearchHasResults(mergedResult)) || !!result.chatResult || !!result.commandResult;

export const assistantSearchHasResults = (result: MergedSearchAndNavigationResult): boolean =>
    result.availabilityBlocks.length > 0 ||
    result.reservations.length > 0 ||
    result.companies.length > 0 ||
    result.bills.length > 0 ||
    result.customers.length > 0 ||
    result.productServiceOrders.length > 0 ||
    result.travelAgencies.length > 0 ||
    result.reservationGroups.length > 0 ||
    result.resourceBlocks.length > 0 ||
    result.navigations.length > 0 ||
    result.resources.length > 0;

export const getSelectedSearchResult = (result: MergedSearchAndNavigationResult, searchType: AssistantSearchType) => {
    switch (searchType) {
        case SearchType.Reservation:
            return result.reservations;
        case SearchType.Company:
            return result.companies;
        case SearchType.Bill:
            return result.bills;
        case SearchType.Customer:
            return result.customers;
        case SearchType.ProductServiceOrder:
            return result.productServiceOrders;
        case SearchType.TravelAgency:
            return result.travelAgencies;
        case SearchType.ReservationGroup:
            return result.reservationGroups;
        case SearchType.ResourceBlock:
            return result.resourceBlocks;
        case SearchType.Resource:
            return result.resources;
        case SearchType.Navigation:
            return result.navigations;
        default: {
            const allResult: Array<SearchTypeResult> = [
                ...result.reservations,
                ...result.companies,
                ...result.bills,
                ...result.customers,
                ...result.productServiceOrders,
                ...result.travelAgencies,
                ...result.reservationGroups,
                ...result.resourceBlocks,
                ...result.resources,
                ...result.navigations,
            ];
            return allResult;
        }
    }
};
